import { useSnapshot } from 'valtio'
import { windowSizeState } from './utils/windowSize'
import { sourcePath } from './utils/path'

import Homepage from './pages/Homepage'
import Intro from './pages/Intro'
import MouseStyle from './pages/MouseStyle'
import DetailPage from './pages/DetailPage'
import { useEffect, useRef } from 'react'
import { uiState } from './data'
import { teamState } from './teamPanoMiddleWare'

function App() {
  const { source, isMusicPlaying } = useSnapshot(uiState.music)
  const { controlled, controller } = useSnapshot(teamState)

  const musicRef = useRef()

  useEffect(() => {
    if (musicRef.current) {
      if (isMusicPlaying) {
        musicRef.current.play()
      } else {
        musicRef.current.pause()
      }
    }
  }, [isMusicPlaying])

  return (
    <div className='App select-none tracking-[2px] overscroll-none screen-setting fixed top-0 left-0 cursor-none'>
      <p className='opacity-0 absolute top-0 left-0 NotoSansB'>
        請以滾輪繼續瀏覽 滑動畫面 預載字
      </p>
      <audio
        controls
        controlsList='nodownload noplaybackrate'
        loop
        src={source.replace('./', sourcePath)}
        ref={musicRef}
        className='absolute top-0 right-0  z-30 pointer-events-none hidden'
      ></audio>
      <Intro event='intro' />
      <Homepage event='homepage' />
      <DetailPage event='detailPage' />
      {!(controlled && !controller) && <MouseStyle event='mouseStyle' />}
      {controlled && !controller && (
        <div className='fixed inset-0 pointer-events-auto z-[1000]'></div>
      )}
    </div>
  )
}

export default App
